


















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { progress } from '@/script/progress';
import api from '@/infrastructure/api/api';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';

@Component({
  components: {
    NormalDialog,
    AlertDialog,
  },
})

export default class ItemExcel extends Vue {
  private アラートメッセージ: string = '';
  private アップロードファイル: File | null = null;

  @Prop({default: false})
  private modal!: boolean;

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.$modal.show('採用品Excel取込ダイアログ画面');
    }
  }

  @Emit('close-form')
  private closeForm() {
    this.$modal.hide('採用品Excel取込ダイアログ画面');
  }

  @Emit('import-after')
  private importAfter(結果: any) {
    this.$modal.hide('採用品Excel取込ダイアログ画面');
    return 結果.取込エラー一覧;
  }

  private onFileChanged(event: any) {
    const files: FileList = event.target.files;
    if (0 < files.length) {
      this.アップロードファイル = files.item(0);
    }
  }

  private executeImport() {
    progress(this.定点発注Excel取込をする);
  }

  private インポート失敗処理(error: any) {
    this.アラートメッセージ = this.サーバリクエストエラーメッセージ(error);
    this.$modal.show('採用品Excel取込実行アラートダイアログ');
  }

  private async 定点発注Excel取込をする(): Promise<void> {
    if (!this.アップロードファイル) {
      return;
    }
    const params = new FormData();
    params.append('name', '採用品一括登録用一覧Excel.xlsx');
    params.append('file', this.アップロードファイル);
    await api.採用品一括登録Excelを取り込む(params)
      .then(this.importAfter, this.インポート失敗処理);
  }

 private サーバリクエストエラーメッセージ(error: any): string {
    if (!error) {
      return 'エラーが発生しました。';
    }
    if (!error.status) {
      return '通信に失敗しました。';
    }
    if (error.status < 400 || error.status >= 500) {
      return 'サーバーでエラーが発生しました。';
    }
    if (!error.data) {
      return 'サーバーでエラーが発生しました。';
    }
    if (error.data.errors) {
      const メッセージ = error.data.errors.join('\n');
      return メッセージ;
    }
    if (error.data.message) {
      return error.data.message;
    }
    return 'エラーが発生しました。';
  }
}

